<script lang="ts">
	import Action from '../../action/Action.svelte'
	import { InputType } from './input'
	import { _ } from '@repo/i18n'

	interface Props {
		type?: InputType
		onChange?: () => void
		children?: import('svelte').Snippet<[{ type: InputType }]>
	}

	let { type = $bindable(InputType.password), onChange, children }: Props = $props()

	function handleVisibilityToggle() {
		type = type === InputType.password ? InputType.text : InputType.password
		onChange()
	}
</script>

{@render children?.({ type })}

<div class="absolute top-0 right-0 bottom-0 flex h-[42px] items-center pr-3">
	<Action
		name="toggle-password-visibility"
		class="text-xs uppercase"
		onclick={handleVisibilityToggle}
	>
		{#if type === InputType.password}
			{$_('button.show')}
		{:else}
			{$_('button.hide')}
		{/if}
	</Action>
</div>
